var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.type,"timeout":_vm.timeOut,"right":true},on:{"input":_vm.onDismissed},model:{value:(_vm.localShow),callback:function ($$v) {_vm.localShow=$$v},expression:"localShow"}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-btn',{attrs:{"dark":"","text":""},on:{"click":_vm.onDismissed}},[_vm._v(" Fechar ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }